export type Optional<T, K extends keyof T> = Pick<Partial<T>, K> & Omit<T, K>;

export enum AppointmentSteps {
    TYPE_VIEW,
    WOMAN_QUANTITY_VIEW,
    MAN_QUANTITY_VIEW,
    SLOTS_VIEW,
    QUANTITY_OVERFLOW,
}

export enum AppointmentTypes {
    NONE = 0,
    BRIDE = 1,
    GROOM = 2,
    WOMAN = 3,
    RETRY_BRIDE = 4,
    RETRY_OTHERS = 5,
    MAN = 7,
    MAN_AND_WOMAN = 6
}

export namespace AppointmentTypes {
    export function toString(type: AppointmentTypes): string {
        switch (type) {
            case AppointmentTypes.BRIDE:
                return "Sposa";
            case AppointmentTypes.GROOM:
                return "Sposo";
            case AppointmentTypes.MAN:
                return "Uomo";
            case AppointmentTypes.MAN_AND_WOMAN:
                return "Uomo + Donna";
            case AppointmentTypes.WOMAN:
                return "Donna";
            case AppointmentTypes.RETRY_BRIDE:
                return "Riprova/Ritiro Sposa";
            case AppointmentTypes.RETRY_OTHERS:
                return "Riprova/Ritiro";
            case AppointmentTypes.NONE:
                return "";
        }
    }
}

export type ModalObjBase = {
    show: boolean,
    text: string,
    onClose : () => void
}

export type ModalObj = Optional<ModalObjBase, "onClose">

export type ModalMergeObj = {
    show: boolean,
    item: ItemAppointment | null
}

export type ModalAppointmentCheckObj = {
    show: boolean,
    selectedType: number,
    customerQuantity: number
}

export type Slot = {
    start: string,
    end: string
}

export type AppointmentDate = {
    date: string,
    slots: Array<Slot>
}

export type ItemAppointment = {
    id: number,
    telefono: string,
    id_documento: string,
    nr_contratto: string,
    nome: string,
    appellativo: string,
    tipo: number,
    stato: string,
    giorni_preavviso: number,
    uuid_contratto: string,
    uuid_messaggio: string,
    id_appuntamento: number | null,
    active: number,
    parent: number | null
}

export type AppointmentSartoria = {
    appointmentType: number,
    men: number,
    women: number,
    items: Array<ItemAppointment>
}

type AppointmentSartoriaOtherBase = {
    appointmentType: number,
    men: number,
    women: number,
    location : "instances" | "others"
    items: Array<ItemAppointment>    
}

export type AppointmentSartoriaOther = Optional<AppointmentSartoriaOtherBase, "location">;

export type TypeAppointmentSartoriaMainInfo = {
    id: number,
    name: string,
    surname: string,
    event_date: string,
    customer_code: string,
    alias: string,
    telephone_number: string,
    max_days: string
}

export type typeAppointmentSartoria = {
    main_contact_info: TypeAppointmentSartoriaMainInfo,
    brides: AppointmentSartoria,
    others: AppointmentSartoria
}

export type onSelectDateCallback = (selectedDate: AppointmentDate | null) => void

export type onSelectAppointmentTypeCallback = (selectedAppointmentType: AppointmentTypes | null) => void;